const overview = {
  revenue: 'Total revenue', 
  credit: 'Total credit', 
  deposit: 'Total deposit', 
  cashflow: 'Total cashflow', 
  total_transaction: 'Total transactions', 
  redemption_balance: 'Redemption balance', 
};

export default overview;